import * as notification from '../../components/notifications';
import {
  getFormData,
  resetFormErrors,
  showFormErrors
} from "../../utils/form";
import {initCustomFieldsTagsInput, setCustomFieldsData} from "../../utils/custom_fields";

let profileInformationForm = null;

const initPage = () => {
  profileInformationForm = $("#job-seeker-profile-information");
  if (!profileInformationForm.length) {
    return;
  }

  profileInformationForm.submit(() => {
    editProfile();
    return false;
  });

  $('#upload-another-file').click((e) => {
    e.preventDefault();
    $(".resume-uploader").removeClass('d-none');
    $("#resume-preview").addClass('d-none');
  })

  initCustomFieldsTagsInput()

};

const getProfileData = () => {
  let formData = getFormData(profileInformationForm);

  formData.available_for_work = formData.available_for_work === true;

  if (formData.custom_fields) {
    formData.custom_fields = setCustomFieldsData(formData.custom_fields, profileInformationForm.attr('id'));
  }

  return formData;
};

const editProfile = async () => {
  const data = getProfileData();

  $('.btn-submit', profileInformationForm).loading();

  try {
    let response = await axios.post("/api/account/edit-job-seeker-profile", data);

    const visibilityRulesMessageContainer =  $('#visibility-rules-message');
    if (response.data.matches_visibility_rules) {
      visibilityRulesMessageContainer.addClass('d-none');
    } else {
      visibilityRulesMessageContainer.removeClass('d-none');
    }

    resetFormErrors(profileInformationForm);
    notification.success(response.data.message);

    $('.btn-submit', profileInformationForm).loading(false);
  } catch (e) {
    console.log('error', e);

    $('.btn-submit', profileInformationForm).loading(false);

    showProfileFormErrors(profileInformationForm, e.response);
  }
};

const showProfileFormErrors = (form, response) => {
  showFormErrors(form, response);

  if (response.data && response.data.errors && (response.data.errors.file || response.data.errors.resume)) {
    $(".form-field-file-container").addClass('dz-container-error');
  } else {
    $(".form-field-file-container").removeClass('dz-container-error');
  }
};

$(initPage);
